import { useAuth } from '@shared/auth/AuthContext';
import { useRecentPages, RecentPage } from '@shared/activity';
import { allSuites } from '@suites/registry';
import { SuiteManifest } from '@suites/manifest';

export interface SearchPageItem {
  id: string;
  label: string;
  path: string;
  suiteName: string;
  icon?: string;
}

export function useSearchIndex(): {
  recentPages: RecentPage[];
  permittedSuites: SuiteManifest[];
  pages: SearchPageItem[];
} {
  const { hasPermission } = useAuth();
  const recentPages = useRecentPages();

  const permittedSuites = allSuites.filter((s) =>
    s.requiredPermission ? hasPermission(s.requiredPermission) : true
  );

  const pages: SearchPageItem[] = [];
  for (const suite of permittedSuites) {
    for (const nav of suite.nav) {
      if (!nav.permission || hasPermission(nav.permission)) {
        pages.push({
          id: `${suite.id}:${nav.path}`,
          label: nav.label,
          path: nav.path,
          suiteName: suite.name,
          icon: nav.icon,
        });
      }
    }
  }

  return { recentPages, permittedSuites, pages };
}
